import {t} from '@lingui/core/macro';

import {HttpMethodType} from 'shared/model/types';

import {normalizeTags} from './normalizeTags';

export interface IBatchOperationRequest {
    method: HttpMethodType,
    data: Record<string, unknown>,
}

export interface IBuildBatchRequestParams<T> {
    actionValue?: string,
    formData: T,
    addedFields: string[],
    selectedIds: string[],
}

const REMOVE_BY_LIST_ACTIONS = ['remove-by-target', 'remove-by-url'];

export function isRemoveByListAction(actionValue?: string): boolean {
    return REMOVE_BY_LIST_ACTIONS.includes(actionValue ?? '');
}

export function buildCommonBatchRequest(
    actionValue: string | undefined,
    selectedIds: string[],
    tags?: string[],
): IBatchOperationRequest {
    switch (actionValue) {
        case 'tags':
            return {method: 'PUT', data: {ids: selectedIds, tags: tags ? normalizeTags(tags) : []}};
        case 'delete':
            return {method: 'DELETE', data: {ids: selectedIds}};
        default:
            return {method: 'PUT', data: {ids: selectedIds}};
    }
}

export function isBatchDeleteAction(actionValue?: string): boolean {
    return actionValue === 'delete' || isRemoveByListAction(actionValue);
}

export function getBatchResultTitle(actionValue?: string): string {
    if (isBatchDeleteAction(actionValue)) {
        return t`Удаление завершено`;
    }

    switch (actionValue) {
        case 'tags':
            return t`Теги обновлены`;
        case 'start':
            return t`Мониторы запущены`;
        case 'stop':
            return t`Мониторы остановлены`;
        case 'edit':
        default:
            return t`Редактирование завершено`;
    }
}

export function getBatchResultCountLabel(actionValue?: string): string | undefined {
    return isRemoveByListAction(actionValue) ? t`Удалено` : undefined;
}

export function getBatchSubmitText(actionValue?: string): string {
    if (actionValue === 'export') {
        return t`Экспортировать`;
    }

    return actionValue === 'edit' || actionValue === 'tags' ? t`Сохранить` : t`Применить`;
}

interface IBatchSubmitState {
    actionValue?: string,
    tagsValue?: unknown[],
    canSubmitEdit: boolean,
    isValid: boolean,
}

export function isBatchSubmitDisabled({actionValue, tagsValue, canSubmitEdit, isValid}: IBatchSubmitState): boolean {
    if (actionValue === 'tags') {
        return !tagsValue || tagsValue.length === 0;
    }

    if (actionValue === 'edit') {
        return !canSubmitEdit || !isValid;
    }

    return !isValid;
}
